import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import withCache from '@framework/with-cache';
import { type IRpcDispatcher } from '@evercall/json-rpc-dispatcher';
import DITypes from '@evercall/json-rpc-dispatcher/DITypes';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { ITimezone } from '@framework/timezone/vo/Timezone';

@injectable()
class EvercallTimeZoneRepository {
  constructor(@inject(DITypes.WebServiceRpcDispatcher) protected readonly rpc: IRpcDispatcher) {}

  @withCache
  async getList(): Promise<ITimezone[]> {
    const request = new Request('evercall.get_time_zones');
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload.collection;
  }
}

export default EvercallTimeZoneRepository;
